<template>

  <Cmor />

</template>

<script>
import Cmor from '../components/pratiche/Cmor.vue'

export default {
  pageName: 'Cmor',
  components: {
    Cmor

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
